import React from 'react';
import * as serviceWorker from './serviceWorker';
import moment from "moment";
import "moment/min/locales.min";
import App from "./App/App";
import store from "./redux";
import Provider from "react-redux/es/components/Provider";
import {Router} from "react-router-dom";
import history from "./utility/history";
import reportWebVitals from "./reportWebVitals";
import {SocketProvider} from "socket.io-react-hooks-advanced";
import {Env} from "./config";
import {createRoot} from "react-dom/client";
import logger from "react-advanced-logger";

window.moment = moment;


logger.config({
    currentEnv: Env.REACT_APP_NODE_ENV,
    envs: ['development', 'staging'],
    minLevel: 'debug',
    prefix: '🪵',
});

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <Provider store={store}>
        <Router history={history}>
            <SocketProvider
                url={Env.REACT_APP_WEB_SOCKET}
                extraHeaders={{platform: "tn_minhngoc_website"}}
                maxRetries={5}>
                <React.StrictMode>
                    <App/>
                </React.StrictMode>
            </SocketProvider>
        </Router>
    </Provider>
);


serviceWorker.register();
reportWebVitals();

